import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface IProfil_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IProfil_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetParametreler: any[];
  GetParametreler_dummy: any[];
  GununTarihi: any[];
  GununTarihi_dummy: any[];
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetFirmayaBagliKullanicilar: any[];
  GetFirmayaBagliKullanicilar_dummy: any[];
  AramaLoglari: any[];
  AramaLoglari_dummy: any[];
  PasswordChange: string;
  PasswordChange_dummy: string;
  Notify: boolean;
  Notify_dummy: boolean;
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp847918Visible: "visible" | "hidden";
}

export class Profil_ScreenBase extends React.PureComponent<
  IProfil_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  profil_82859_value_kuikaDateRef: React.RefObject<any>;
  profil_162181_value_kuikaDateRef: React.RefObject<any>;
  profil_541837_value_kuikaTableRef: React.RefObject<any>;
  profil_387206_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 808053,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 978829,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 785850,
          PropertyName: "value",
          Value: "ACCOUNT INFORMATION",
          TagName: "Label17_4_value",
        },
        {
          Id: 305344,
          PropertyName: "value",
          Value: "VIEW ACCOUNT INFORMATION AND EDIT",
          TagName: "Label64_value",
        },
        {
          Id: 179805,
          PropertyName: "tab",
          Value: "GENERAL INFORMATION",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 802634,
          PropertyName: "tab",
          Value: "SEARCH LOG",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 77411,
          PropertyName: "tab",
          Value: "UPDATE PASSWORD",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 202183,
          PropertyName: "tab",
          Value: "USERS",
          TagName: "TabItem4_tab",
        },
        {
          Id: 285314,
          PropertyName: "label",
          Value: "SAVE",
          TagName: "Button2_label",
        },
        {
          Id: 387206,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORDS FOUND TO LIST",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 666754,
          PropertyName: "value",
          Value: "COMPANY NAME",
          TagName: "Label1_value",
        },
        {
          Id: 222148,
          PropertyName: "value",
          Value: "ADDRESS",
          TagName: "Label16_value",
        },
        {
          Id: 280504,
          PropertyName: "value",
          Value: "PHONE",
          TagName: "Label3_value",
        },
        {
          Id: 179137,
          PropertyName: "value",
          Value: "COUNTRY",
          TagName: "Label8_value",
        },
        {
          Id: 644633,
          PropertyName: "value",
          Value: "CITY",
          TagName: "Label12_value",
        },
        {
          Id: 38594,
          PropertyName: "value",
          Value: "COUNTY",
          TagName: "Label10_value",
        },
        {
          Id: 589704,
          PropertyName: "value",
          Value: "TAX OFFICE",
          TagName: "Label6_value",
        },
        {
          Id: 49209,
          PropertyName: "value",
          Value: "TAX NO",
          TagName: "Label4_value",
        },
        {
          Id: 53937,
          PropertyName: "value",
          Value: "OLD PASSWORD",
          TagName: "Label24_value",
        },
        {
          Id: 128365,
          PropertyName: "value",
          Value: "NEW PASSWORD",
          TagName: "Label25_value",
        },
        {
          Id: 541837,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORDS FOUND TO LIST",
          TagName: "Table0_nodatafoundmessage",
        },
        {
          Id: 579443,
          PropertyName: "title",
          Value: "REGISTRATION DATE",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 77451,
          PropertyName: "title",
          Value: "USER NAME",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 985646,
          PropertyName: "title",
          Value: "LAST LOG IN",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 82859,
          PropertyName: "placeholder",
          Value: "START DATE",
          TagName: "Date0_placeholder",
        },
        {
          Id: 162181,
          PropertyName: "placeholder",
          Value: "END DATE",
          TagName: "Date1_placeholder",
        },
        {
          Id: 320362,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 169793,
          PropertyName: "title",
          Value: "SEARCH DATA",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 836517,
          PropertyName: "title",
          Value: "REGISTRATION NUMBER",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 3527,
          PropertyName: "title",
          Value: "DETAILS",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 822940,
          PropertyName: "label",
          Value: "LIST ALL",
          TagName: "Button0_label",
        },
        {
          Id: 13219118,
          PropertyName: "ef9ad13e-fbcd-71a5-1b1e-5bdeaef7d9cc_notify",
          Value: "PASSWORD UPDATED",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 808053,
          PropertyName: "placeholder",
          Value: "Vaden No, OEM No, Nom du produit, Marque, Modèle, Véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 978829,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 785850,
          PropertyName: "value",
          Value: "Informations du compte",
          TagName: "Label17_4_value",
        },
        {
          Id: 305344,
          PropertyName: "value",
          Value: "Vous pouvez modifier et consulter vos informations de compte",
          TagName: "Label64_value",
        },
        {
          Id: 179805,
          PropertyName: "tab",
          Value: "Informations générales",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 802634,
          PropertyName: "tab",
          Value: "Historique des recherches",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 77411,
          PropertyName: "tab",
          Value: "Mettre à jour le mot de passe",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 202183,
          PropertyName: "tab",
          Value: "Utilisateurs",
          TagName: "TabItem4_tab",
        },
        {
          Id: 285314,
          PropertyName: "label",
          Value: "Enregistrer",
          TagName: "Button2_label",
        },
        {
          Id: 387206,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun enregistrement à afficher",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 666754,
          PropertyName: "value",
          Value: "Nom du client",
          TagName: "Label1_value",
        },
        {
          Id: 222148,
          PropertyName: "value",
          Value: "Adresse",
          TagName: "Label16_value",
        },
        {
          Id: 280504,
          PropertyName: "value",
          Value: "Téléphone",
          TagName: "Label3_value",
        },
        {
          Id: 179137,
          PropertyName: "value",
          Value: "Pays",
          TagName: "Label8_value",
        },
        {
          Id: 644633,
          PropertyName: "value",
          Value: "Région / Province",
          TagName: "Label12_value",
        },
        {
          Id: 38594,
          PropertyName: "value",
          Value: "Ville / District",
          TagName: "Label10_value",
        },
        {
          Id: 589704,
          PropertyName: "value",
          Value: "Bureau des impôts",
          TagName: "Label6_value",
        },
        {
          Id: 49209,
          PropertyName: "value",
          Value: "Numéro de TVA",
          TagName: "Label4_value",
        },
        {
          Id: 53937,
          PropertyName: "value",
          Value: "Ancien mot de passe",
          TagName: "Label24_value",
        },
        {
          Id: 128365,
          PropertyName: "value",
          Value: "Nouveau mot de passe",
          TagName: "Label25_value",
        },
        {
          Id: 541837,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun enregistrement à afficher",
          TagName: "Table0_nodatafoundmessage",
        },
        {
          Id: 579443,
          PropertyName: "title",
          Value: "Date d’enregistrement",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 77451,
          PropertyName: "title",
          Value: "Nom d’utilisateur",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 985646,
          PropertyName: "title",
          Value: "Dernière connexion",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 82859,
          PropertyName: "placeholder",
          Value: "Date de début",
          TagName: "Date0_placeholder",
        },
        {
          Id: 162181,
          PropertyName: "placeholder",
          Value: "Date de fin",
          TagName: "Date1_placeholder",
        },
        {
          Id: 320362,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 169793,
          PropertyName: "title",
          Value: "Donnée recherchée",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 836517,
          PropertyName: "title",
          Value: "Nombre d’enregistrements",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 3527,
          PropertyName: "title",
          Value: "Détails",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 822940,
          PropertyName: "label",
          Value: "Détails",
          TagName: "Button0_label",
        },
        {
          Id: 8113173,
          PropertyName: "ef9ad13e-fbcd-71a5-1b1e-5bdeaef7d9cc_notify",
          Value: "Mot de passe mis à jour avec succès",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 808053,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. de oem, nombre de producto, marca, modelo, vehiculo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 978829,
          PropertyName: "label",
          Value: "Perfil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 785850,
          PropertyName: "value",
          Value: "Información de la cuenta",
          TagName: "Label17_4_value",
        },
        {
          Id: 305344,
          PropertyName: "value",
          Value: "Editar y ver la información de su cuenta",
          TagName: "Label64_value",
        },
        {
          Id: 179805,
          PropertyName: "tab",
          Value: "Información general",
          TagName: "TabItem1_0_tab",
        },
        {
          Id: 802634,
          PropertyName: "tab",
          Value: "Registros de búsqueda",
          TagName: "TabItem1_1_tab",
        },
        {
          Id: 77411,
          PropertyName: "tab",
          Value: "Actualizar contraseña",
          TagName: "TabItem1_2_tab",
        },
        {
          Id: 202183,
          PropertyName: "tab",
          Value: "Usuarios",
          TagName: "TabItem4_tab",
        },
        {
          Id: 285314,
          PropertyName: "label",
          Value: "Guardar",
          TagName: "Button2_label",
        },
        {
          Id: 387206,
          PropertyName: "nodatafoundmessage",
          Value: "No se han encontrado registros para mostrar ",
          TagName: "Table2_nodatafoundmessage",
        },
        {
          Id: 666754,
          PropertyName: "value",
          Value: "Nombre comercial",
          TagName: "Label1_value",
        },
        {
          Id: 222148,
          PropertyName: "value",
          Value: "Dirección",
          TagName: "Label16_value",
        },
        {
          Id: 280504,
          PropertyName: "value",
          Value: "Teléfono",
          TagName: "Label3_value",
        },
        {
          Id: 179137,
          PropertyName: "value",
          Value: "País",
          TagName: "Label8_value",
        },
        {
          Id: 644633,
          PropertyName: "value",
          Value: "Ciudad",
          TagName: "Label12_value",
        },
        {
          Id: 38594,
          PropertyName: "value",
          Value: "Distrito",
          TagName: "Label10_value",
        },
        {
          Id: 589704,
          PropertyName: "value",
          Value: "Oficina tributaria",
          TagName: "Label6_value",
        },
        {
          Id: 49209,
          PropertyName: "value",
          Value: "Número de identificación fiscal",
          TagName: "Label4_value",
        },
        {
          Id: 53937,
          PropertyName: "value",
          Value: "Contraseña anterior",
          TagName: "Label24_value",
        },
        {
          Id: 128365,
          PropertyName: "value",
          Value: "Contraseña nueva",
          TagName: "Label25_value",
        },
        {
          Id: 541837,
          PropertyName: "nodatafoundmessage",
          Value: "No se han encontrado registros para mostrar ",
          TagName: "Table0_nodatafoundmessage",
        },
        {
          Id: 579443,
          PropertyName: "title",
          Value: "Fecha de registro",
          TagName: "TableTemplateColumn7_title",
        },
        {
          Id: 77451,
          PropertyName: "title",
          Value: "Nombre de usuario",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 985646,
          PropertyName: "title",
          Value: "Última sesión",
          TagName: "TableTemplateColumn4_title",
        },
        {
          Id: 82859,
          PropertyName: "placeholder",
          Value: "Fecha de inicio ",
          TagName: "Date0_placeholder",
        },
        {
          Id: 162181,
          PropertyName: "placeholder",
          Value: "Fecha de expiración",
          TagName: "Date1_placeholder",
        },
        {
          Id: 320362,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 169793,
          PropertyName: "title",
          Value: "Datos buscados",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 836517,
          PropertyName: "title",
          Value: "Numero de registros",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 3527,
          PropertyName: "title",
          Value: "Detalle",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 822940,
          PropertyName: "label",
          Value: "Agregar",
          TagName: "Button0_label",
        },
        {
          Id: 18222904,
          PropertyName: "ef9ad13e-fbcd-71a5-1b1e-5bdeaef7d9cc_notify",
          Value: "Contraseña actualizada correctamente",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "6e3cc5ae-cad5-4730-8d10-e23664101eaf",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 808053,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 813330, PropertyName: "label", Value: "Turkish" },
        { Id: 508496, PropertyName: "label", Value: "English" },
        { Id: 9076, PropertyName: "label", Value: "Spanish" },
        { Id: 711920, PropertyName: "label", Value: "French" },
        { Id: 978829, PropertyName: "label", Value: "Profil" },
        { Id: 785850, PropertyName: "value", Value: "Hesap Bilgileri" },
        {
          Id: 305344,
          PropertyName: "value",
          Value: "Hesap Bilgilerinizi Düzenleyip Görüntüleyebilirsiniz",
        },
        { Id: 179805, PropertyName: "tab", Value: "Genel Bilgiler" },
        { Id: 666754, PropertyName: "value", Value: "Cari İsim" },
        { Id: 222148, PropertyName: "value", Value: "Adres" },
        { Id: 280504, PropertyName: "value", Value: "Telefon" },
        { Id: 179137, PropertyName: "value", Value: "Ülke" },
        { Id: 644633, PropertyName: "value", Value: "İl" },
        { Id: 38594, PropertyName: "value", Value: "İlçe" },
        { Id: 589704, PropertyName: "value", Value: "Vergi Dairesi" },
        { Id: 49209, PropertyName: "value", Value: "Vergi No" },
        { Id: 802634, PropertyName: "tab", Value: "Arama Logları" },
        { Id: 82859, PropertyName: "placeholder", Value: "Başlangıç Tarihi" },
        { Id: 162181, PropertyName: "placeholder", Value: "Bitiş Tarihi" },
        { Id: 822940, PropertyName: "label", Value: "Listele" },
        {
          Id: 541837,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 320362, PropertyName: "title", Value: "Tarih" },
        { Id: 512845, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 169793, PropertyName: "title", Value: "Aranan Veri" },
        {
          Id: 569167,
          PropertyName: "value",
          Value: "[datafield:aranankelime]",
        },
        { Id: 836517, PropertyName: "title", Value: "Kayıt Sayısı" },
        {
          Id: 843124,
          PropertyName: "value",
          Value: "[datafield:toplamdonenveri]",
        },
        { Id: 3527, PropertyName: "title", Value: "Detay" },
        { Id: 77411, PropertyName: "tab", Value: "Şifre Güncelle" },
        { Id: 53937, PropertyName: "value", Value: "Eski Şifre" },
        { Id: 128365, PropertyName: "value", Value: "Yeni Şifre" },
        { Id: 285314, PropertyName: "label", Value: "Kaydet" },
        { Id: 202183, PropertyName: "tab", Value: "Kullanıcılar" },
        {
          Id: 387206,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 579443, PropertyName: "title", Value: "Kayıt Tarihi" },
        { Id: 425940, PropertyName: "value", Value: "[datafield:kayittarihi]" },
        { Id: 77451, PropertyName: "title", Value: "Kullanıcı Adı" },
        {
          Id: 412651,
          PropertyName: "value",
          Value: "[datafield:kullanicikodu]",
        },
        { Id: 985646, PropertyName: "title", Value: "Son Login" },
        {
          Id: 386658,
          PropertyName: "value",
          Value: "[datafield:lastlogindate]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.profil_808053_value_kuikaTextInputRef = React.createRef();
    this.profil_82859_value_kuikaDateRef = React.createRef();
    this.profil_162181_value_kuikaDateRef = React.createRef();
    this.profil_541837_value_kuikaTableRef = React.createRef();
    this.profil_733141_value_kuikaTextInputRef = React.createRef();
    this.profil_10662_value_kuikaTextInputRef = React.createRef();
    this.profil_387206_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetParametreler: [],
      GununTarihi: [],
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetFirmayaBagliKullanicilar: [],
      AramaLoglari: [],
      PasswordChange: "",
      Notify: false,
      SetValueOf: "",
      isComp847918Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("profil", "blank_screen");
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ProfilPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.ProfilPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("profil", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("profil", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ProfilPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ProfilPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      profil_82859_value: this.state.GununTarihi?.at?.(0)?.bugun ?? undefined,
      profil_162181_value: this.state.GununTarihi?.at?.(0)?.bugun ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  ProfilPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Profil/ProfilPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetParametreler = result?.data.getParametreler;
    stateVars.isComp847918Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GununTarihi = result?.data.gununTarihi;
    formVars.profil_82859_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );
    formVars.profil_162181_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );
    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.profil_446821_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfilPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfilPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfilPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  ProfilPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      KullaniciID_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      bastar_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "profil_82859_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      bittar_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "profil_162181_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Profil/ProfilPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    formVars.profil_682870_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );
    formVars.profil_132437_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ADRES
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ADRES
        : null
    );
    formVars.profil_951792_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_TEL
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_TEL
        : null
    );
    formVars.profil_760109_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].ulkE_KODU
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].ulkE_KODU
        : null
    );
    formVars.profil_381897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_IL
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_IL
        : null
    );
    formVars.profil_592142_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ILCE
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ILCE
        : null
    );
    formVars.profil_604592_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].vergI_DAIRESI
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].vergI_DAIRESI
        : null
    );
    formVars.profil_607257_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].vergI_NUMARASI
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].vergI_NUMARASI
        : null
    );
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.profil_502809_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.profil_907747_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetFirmayaBagliKullanicilar =
      result?.data.getFirmayaBagliKullanicilar;

    stateVars.AramaLoglari = result?.data.aramaLoglari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfilPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfilPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.profil_502809_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    stateVars.isComp847918Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetParametreler !== undefined
            ? stateVars.GetParametreler?.length > 0
              ? stateVars.GetParametreler[0].isTeklif
              : null
            : this.state.GetParametreler?.length > 0
            ? this.state.GetParametreler[0].isTeklif
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.profil_907747_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.profil_446821_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.profil_5772_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.profil_682870_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    formVars.profil_132437_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ADRES
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ADRES
        : null
    );

    formVars.profil_951792_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_TEL
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_TEL
        : null
    );

    formVars.profil_760109_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].ulkE_KODU
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].ulkE_KODU
        : null
    );

    formVars.profil_381897_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_IL
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_IL
        : null
    );

    formVars.profil_592142_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ILCE
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ILCE
        : null
    );

    formVars.profil_604592_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].vergI_DAIRESI
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].vergI_DAIRESI
        : null
    );

    formVars.profil_607257_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].vergI_NUMARASI
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].vergI_NUMARASI
        : null
    );

    formVars.profil_82859_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );

    formVars.profil_162181_value = ReactSystemFunctions.value(
      this,
      stateVars.GununTarihi !== undefined
        ? stateVars.GununTarihi?.length > 0
          ? stateVars.GununTarihi[0].bugun
          : null
        : this.state.GununTarihi?.length > 0
        ? this.state.GununTarihi[0].bugun
        : null
    );

    stateVars.dataSource_541837 =
      stateVars.AramaLoglari ?? this.state.AramaLoglari;

    stateVars.dataSource_387206 =
      stateVars.GetFirmayaBagliKullanicilar ??
      this.state.GetFirmayaBagliKullanicilar;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ProfilComponent_808053_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "profil_808053_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Profil",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_847918_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Profil",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_267490_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Profil",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "768004",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_813330_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_508496_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_9076_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_711920_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_978829_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Profil",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_822940_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      bastar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "profil_82859_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      bittar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "profil_162181_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Profil/ProfilComponent_822940_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.AramaLoglari = result?.data.aramaLoglari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.ProfilComponent_822940_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ProfilComponent_822940_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_541837 =
      stateVars.AramaLoglari ?? this.state.AramaLoglari;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_86098_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "profil_541837_value", "arananKelime"),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Profil",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ProfilComponent_285314_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.PasswordChange = await ReactSystemFunctions.changePassword(
      this,
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "profil_733141_value",
          "value",
          "",
          "",
          ""
        )
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "profil_10662_value",
          "value",
          "",
          "",
          ""
        )
      ),
      false,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      undefined
    );
    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ef9ad13e_fbcd_71a5_1b1e_5bdeaef7d9cc_notify",
        this.defaultML,
        "Şifre Başarıyla Güncellendi"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top-center", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("profil_733141_value", "string"),
      null,
      null,
      null
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName("profil_10662_value", "string"),
      null,
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 768004, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ProfilPageInit();
    }
  }
}
